import React, { useState, useEffect, useRef } from "react";
import AudioPlayer from "../../QuestionPage/AudioPlayer";
import FillInTheBlanksInput from "../../QuestionPage/FillInTheBlanksInput";
// Fetching Data from the API]

// End

// Page Html
export default function FillInTheBlanksMockPage({ question, onInputChange, questionNumber, maxQuestion }) {
  const [originalWords, setOriginalWords] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [audioLink, setAudioLink] = useState("");
  const audioRef = useRef(null);

  useEffect(() => {
    setAudioLink(question.media_link);
    setOriginalWords(question.question);
    resetAudio();
  }, [question]);

  const resetAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };
  const handleRetake = () => {
    setSubmitted(false);
  };

  const handleIsAttempted = () => {};

  const handleUserInput = (userInput) => {
    if (onInputChange) onInputChange(userInput);
    console.log("User Input:", userInput); // Optional: Log user input for debugging or further processing
  };

  return (
    <div>
      <div className="min-h-[calc(100vh-230px)] overflow-hidden rounded-md border border-slate-200 bg-white p-4 shadow-sm sm:p-6 lg:p-8">
        <div className="h-1.5 rounded-full bg-violet-600"></div>
        <h3 className="pt-4 text-2xl font-extrabold text-gray-900 sm:text-3xl">
          Listening Fill in the Blanks
        </h3>
        <h2 className="hidden">
          {" "}
        </h2>
        <h2 className="mt-3 inline-flex rounded-md bg-violet-50 px-3 py-2 text-sm font-bold text-violet-800 ring-1 ring-violet-100">
          {" "}
          Question {questionNumber} of {maxQuestion}
        </h2>
        <p className="mt-4 max-w-5xl text-sm leading-6 text-gray-600 sm:text-base">
          Listen to the recording and type the missing words in each blank.
        </p>
        {audioLink && <AudioPlayer audioSrc={audioLink} audioRef={audioRef} />}

        {/* <div className="font-bold p-2 pt-4 ml-[1000px] ">Time left:9.22 </div> */}
        <FillInTheBlanksInput
          sentence={originalWords}
          options={[]}
          submitted={submitted}
          onSubmit={handleUserInput} // Pass callback function to receive userInput
          onRetake={handleRetake}
          onIsAttempted={handleIsAttempted}
        />      </div>
    </div>
  );
}


